<template>
  <template v-if="price && productResponse && selectedOffer">
    <slot :price :product="productResponse" :selected-offer>
      <Price
        class="grow"
        :is-from-google-shopping
        :mobile-plan="selectedMobilePlan"
        :price
        :product="productResponse"
        :selected-offer
      />
    </slot>
  </template>
</template>

<script setup lang="ts">
import { useRoute } from '#imports'
import { computed } from 'vue'

import Price from '~/scopes/product-core/components/presentationals/Price/Price.vue'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import { useFetchProductPrice } from '~/scopes/product-core/composables/useFetch/useFetchProductPrice/useFetchProductPrice'
import { useSelectedMobilePlan } from '~/scopes/product-core/composables/useSelectedMobilePlan/useSelectedMobilePlan'

const route = useRoute()
const { data: productResponse } = useFetchProduct()
const { selectedOffer } = useFetchPickers()
const { price } = useFetchProductPrice()
const selectedMobilePlan = useSelectedMobilePlan()

const isFromGoogleShopping = computed(() => route.query.utm_source === 'google')
</script>
